import axios from '../utils/axios';
import Constants from './types';
import store from '../store';
import { getSelectedEntity, getPayloadFromError } from '../utils';

export const getUserFiles = () => {
  const sessionId = store.getState().session.sessionId;
  return dispatch => {
    dispatch(getUserFilesRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/files',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getUserFilesSuccess(res.data));
      })
      .catch(err => {
        dispatch(getUserFilesFailure(err));
      });
  };
};

export const deleteUserFile = userFileId => {
  const sessionId = store.getState().session.sessionId;
  return dispatch => {
    dispatch(deleteUserFilesRequest());
    axios({
      method: 'delete',
      url: '/openempi-ws-rest/1.0/files/' + userFileId,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(deleteUserFilesSuccess(res.data));
      })
      .catch(err => {
        dispatch(deleteUserFilesFailure(err));
      });
  };
};

export const updateUserFile = userFile => {
  const sessionId = store.getState().session.sessionId;
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/files/' + userFile.userFileId,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: userFile
    })
      .then(res => {
        dispatch(updateUserFilesSuccess(res.data));
      })
      .catch(err => {
        dispatch(updateUserFilesFailure(err));
      });
  };
};

export const importUserFile = (userFileId, fileImportParams) => {
  const sessionId = store.getState().session.sessionId;
  const entity = getSelectedEntity();
  return dispatch => {
    axios({
      method: 'put',
      url: '/openempi-ws-rest/1.0/records/importFile',
      headers: {
        'Content-Type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entity.entityVersionId,
        fieldMapFilename: fileImportParams.mappingFilename,
        isImport: fileImportParams.isImport,
        isMassiveInsert: fileImportParams.isBulkImport,
        isSynchronous: fileImportParams.isSynchronous,
        skipHeaderLine: fileImportParams.skipHeaderLine,
        userFileId: userFileId
      }
    })
      .then(res => {
        dispatch(importStarted());
        dispatch(getUserFiles());
      })
      .catch(err => {
        dispatch(getUserFilesFailure(err));
      });
  };
};

export const uploadUserFile = formData => {
  const sessionId = store.getState().session.sessionId;
  return dispatch => {
    axios({
      method: 'post',
      url: '/openempi-ws-rest/1.0/files',
      headers: {
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: formData
    })
      .then(res => {
        dispatch(getUserFiles());
      })
      .catch(err => {
        dispatch(getUserFilesFailure(err));
      });
  };
};

export const clearUserFileError = () => {
  return {
    type: Constants.USER_FILES_CLEARERROR
  };
};

const importStarted = () => {
  return {
    type: Constants.USER_FILES_IMPORT_STARTED
  };
};

const getUserFilesRequest = () => {
  return {
    type: Constants.USER_FILES_GET_REQUEST
  };
};

const getUserFilesSuccess = data => {
  return {
    type: Constants.USER_FILES_GET_SUCCESS,
    payload: data
  };
};

const getUserFilesFailure = err => {
  const payload = getPayloadFromError(err);
  if (err && err.response && err.response.status === 404) {
    return {
      type: Constants.USER_FILES_GET_SUCCESS,
      payload: []
    };
  }
  return {
    type: Constants.USER_FILES_GET_FAILURE,
    payload
  };
};

const deleteUserFilesRequest = () => {
  return {
    type: Constants.USER_FILES_DELETE_REQUEST
  };
};

const deleteUserFilesSuccess = data => {
  return {
    type: Constants.USER_FILES_DELETE_SUCCESS,
    payload: data
  };
};

const updateUserFilesSuccess = data => {
  return {
    type: Constants.USER_FILES_UPDATE_SUCCESS,
    payload: data
  };
};

const updateUserFilesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.USER_FILES_UPDATE_FAILURE,
    payload
  };
};

const deleteUserFilesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.USER_FILES_DELETE_FAILURE,
    payload
  };
};
